export default {
  data () {
    return {
      imageSizes: {
        D_xl: {
          width: 600,
          height: 360
        },
        T_xl: {
          width: 600,
          height: 360
        },
        S_xl: {
          width: 600,
          height: 360
        },
        D_l: {
          width: 640,
          height: 480
        },
        T_l: {
          width: 712,
          height: 480
        },
        S_l: {
          width: 355,
          height: 240
        },
        D_s: {
          width: 420,
          height: 250
        },
        T_s: {
          width: 345,
          height: 250
        },
        S_s: {
          width: 355,
          height: 250
        },
        D_xs: {
          width: 420,
          height: 250
        },
        T_xs: {
          width: 345,
          height: 250
        },
        S_xs: {
          width: 295,
          height: 250
        },
        lg: {
          width: 800,
          height: 600
        },
        md: {
          width: 640,
          height: 480
        },
        sm: {
          width: 320,
          height: 150
        }
      }
    }
  },
  methods: {
    // go to route
    goTo (name, params = null, query = null) {
      console.log('GO TO', name, params, query)
      if (params && query) {
        this.$router.push({ name, params, query })
      } else if (params) {
        this.$router.push({ name, params })
      } else if (query) {
        this.$router.push({ name, query })
      } else {
        this.$router.push({ name })
      }
    },
    // mix array
    shuffle (array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
      }
    },
    isIOS () {
      var iDevices = [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ]
      if (navigator.platform) {
        while (iDevices.length) {
          if (navigator.platform === iDevices.pop()) {
            return true
          }
        }
      }
      return false
    },
    iphoneModalsSet () {
      var InitialWidth = document.body.offsetWidth
      document.body.style.overflow = 'hidden'
      document.body.style.height = '100%'
      document.body.style.width = '100%'
      document.body.style.paddingRight = Math.abs(InitialWidth - document.body.offsetWidth) + 'px'
      if (this.isIOS()) {
        document.body.style.position = 'fixed'
      }
    },
    iphoneModalsUnset () {
      document.body.style.overflow = 'auto'
      document.body.style.height = '100%'
      document.body.style.width = '100%'
      document.body.style.paddingRight = 'initial'
      if (this.isIOS()) {
        document.body.style.position = 'initial'
      }
    },
    hasStatus (expected, status, isNotBitWise) {
      return isNotBitWise ? expected === status : expected & status
    },
    isLineSessionFinished (line) {
      return this.hasStatus(line.status_options['STATUS_SESSION_SUCCESS'], line.status)
    },
    isLineSessionCanceled (line) {
      return this.hasStatus(line.status_options['STATUS_SESSION_CANCELED'], line.status)
    },
    isLineSessionError (line) {
      return this.hasStatus(line.status_options['STATUS_SESSION_ERROR'], line.status)
    },
    isOrderPaid (order) {
      return this.hasStatus(order.status_options['STATUS_PAID'], order.status)
    },
    isOrderCanceled (order) {
      return this.hasStatus(order.status_options['STATUS_CANCELED'], order.status)
    },
    isOrderPaymentPending (order) {
      return this.hasStatus(order.status_options['STATUS_PAYMENT_PENDING'], order.status)
    },
    isOrderPaymentWarning (order) {
      return this.hasStatus(order.status_options['STATUS_PAYMENT_WARNING'], order.status)
    },
    isOrderPreparedForDelivery (order) {
      return this.hasStatus(order.status_options['STATUS_PREPARED_FOR_DELIVERY'], order.status)
    },
    isOrderInDelivery (order) {
      return this.hasStatus(order.status_options['STATUS_IN_DELIVERY'], order.status)
    },
    isOrderDelivered (order) {
      return this.hasStatus(order.status_options['STATUS_DELIVERED'], order.status)
    },
    isOrderRefunded (order) {
      return this.hasStatus(order.status_options['STATUS_REFUNDED'], order.status)
    },
    getOrderStatusText (order) {
      if (this.isOrderRefunded(order)) {
        return ['Storniert mit Rückzahlung', '']
      }
      if (this.isOrderCanceled(order)) {
        return ['Storniert', '']
      }
      if (this.isOrderPaid(order)) {
        if (this.isOrderDelivered(order)) {
          return ['Abgeschlossen', '']
        }
        if (this.isOrderInDelivery(order)) {
          return ['In Auslieferung', '']
        }
        if (this.isOrderPreparedForDelivery(order)) {
          return ['Lieferung wird vorbereitet', '']
        }
        return ['Bestellung wird vorbereitet', '']
      } else {
        if (this.isOrderPaymentWarning(order)) {
          return ['Zahlung konnte nicht durchgeführt werden', '']
        }
        if (this.isOrderPaymentPending(order) && order.type === 'catalog') {
          return ['Bestellung wird vom Händler überprüft', '']
        }
        return ['Wartet auf Zahlung', 'Wenn Du schon bezahlt hast, wende Dich bitte an unseren Support!']
      }
    },
    getOrderStatusShortText (order) {
      if (this.isOrderRefunded(order)) {
        return ['Rückzahlung', '']
      }
      if (this.isOrderCanceled(order)) {
        return ['Storniert', '']
      }
      if (this.isOrderPaid(order)) {
        if (this.isOrderDelivered(order)) {
          return ['Abgeschlossen', '']
        }
        if (this.isOrderInDelivery(order)) {
          return ['Unterwegs', '']
        }
        if (this.isOrderPreparedForDelivery(order)) {
          return ['Warten..', '']
        }
        return ['Bezahlt', '']
      } else {
        if (this.isOrderPaymentWarning(order)) {
          return ['Zahlungsproblem', '']
        }
        if (this.isOrderPaymentPending(order) && order.type === 'catalog') {
          return ['Überprüfung', '']
        }
        return ['Warten..', '']
      }
    },
    // get shop or product images by object
    getImg (obj, size) {
      let path = ''
      let url = false
      if (typeof obj !== 'undefined') {
        if (obj.hasOwnProperty('shopImages') && obj.shopImages.data.length > 0) {
          url = obj.shopImages.data[0].url
        } else if (obj.hasOwnProperty('productImages') && obj.productImages.data.length > 0) {
          url = obj.productImages.data[0].url
        }
        if (url) {
          path = this.getImgFromImgObj({url: url}, size)
        }
      }
      return path
    },
    getImgFromImgObj (img, size) {
      var url = img.url
      var sizes = this.imageSizes.lg
      switch (size) {
        case 'md':
          sizes = this.imageSizes.md
          break
        case 'sm':
          sizes = this.imageSizes.sm
          break
        default:
          sizes = this.imageSizes.lg
      }
      var path = url.template.replace('{width}', sizes.width).replace('{height}', sizes.height)
      return path
    },
    getImageTemplateFromObject (obj) {
      var template = ''
      if (typeof obj !== 'undefined') {
        if (obj.hasOwnProperty('shopImages') && obj.shopImages.data.length > 0) {
          template = obj.shopImages.data[0].url.template
        } else if (obj.hasOwnProperty('productImages') && obj.productImages.data.length > 0) {
          template = obj.productImages.data[0].url.template
        } else if (obj.hasOwnProperty('url')) {
          template = obj.url.template
        }
      }
      return template
    },
    replaceInImageTemplate (template, size, multiplier = 1) {
      var sizes = this.imageSizes[size]
      return template.replace('{width}', sizes.width * multiplier).replace('{height}', sizes.height * multiplier) + '?fit=crop-top'
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js